import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal } from "../../../common-components/modal";
import { UploadMain } from "./upload-components";
import { setUploadModal } from "../../../redux/actions/appUtils";
import UploadTabs from "./UploadTabs";

import DragUpload from "./dragUpload";
import Library from "./library";
import content from "../../../constants/content";

const uploadAudios = "Upload Audios";
const library = "Library";

const tabs = [
    { label: uploadAudios, content: <DragUpload /> },
    { label: library, content: <Library /> },
];

const UploadModal = () => {
    const dispatch = useDispatch();
    const appReducer = useSelector((state) => state.app);
    const { show } = appReducer.get("upload").toJS();
    const enableFooter = appReducer.isEnableFooter;
    const uploadData = appReducer.get("upload").toJS();

    const [, setLoading] = useState(false);

    const onClose = useCallback((e, isLoad = false) => {
        dispatch(setUploadModal({ show: false }));
        setLoading(isLoad);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <UploadMain enableFooter={enableFooter} style={{
            visibility: uploadData?.assetData?.length > 0 ? "visible" : "hidden"
        }}>
            <Modal
                width="73.055vw"
                height="580px"
                showModal={show}
                onClose={onClose}
                className="upload--modal"
                isRender={true}
                closeIconPath={'vm-close-new.svg'}
                closeIconWidth="24px"
                closeIconHeight="24px"
                closeIconRight="16px"
                closeIconTop="24px"
                closeIconMobTop="9%"
                closeIconMobRight="%"
            >
                <UploadTabs title={content.UPLOAD_IMPORT_AUDIOS} tabs={tabs} />
            </Modal>
        </UploadMain>
    );
};

export default UploadModal;
